import { render, staticRenderFns } from "./Inserts.vue?vue&type=template&id=4c3c06ee&"
import script from "./Inserts.vue?vue&type=script&lang=js&"
export * from "./Inserts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports